<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="75%">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>{{ expense.label }} Expense</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                         density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>
                <v-row>
                    <v-col class="py-0" cols="12">
                        <h4>Expense Details</h4>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-1" cols="6">
                        <v-text-field v-model="expenseData['label']" :rules="[vRules.required]"
                                      density="compact" hide-details label="Label"/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-select v-model="expenseData['driver_id']" :items="drivers"
                                  density="compact" hide-details :item-title="d => `${d.first_name || ''} ${d.last_name || ''}`.trim()" item-value="id"
                                  label="Driver"/>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0 my-3" cols="12">
                        <div class="d-flex justify-space-between">
                            <h4>Expense List</h4>
                            <v-btn color="black" icon="mdi-plus" size="x-small" variant="flat" @click="addItem"/>
                        </div>
                        <v-table fixed-header style="max-height: 250px; overflow: auto">
                            <thead>
                            <tr>
                                <th class="font-weight-bold">Expense Type</th>
                                <th class="font-weight-bold">Notes</th>
                                <th class="font-weight-bold">Qty</th>
                                <th class="font-weight-bold">Unit Cost</th>
                                <th class="font-weight-bold">Tax</th>
                                <th class="font-weight-bold">Total</th>
                                <th class="font-weight-bold">Action</th>
                            </tr>
                            </thead>
                            <tbody class="text-caption">
                            <tr v-if="newExpenseItem">
                                <td class="pa-0">
                                    <v-select v-model="newExpenseItem['vehicle_expense_type_id']" :items="expenseTypes"
                                              :rules="[vRules.required]" density="compact" hide-details
                                              item-title="name"
                                              item-value="id" label="Expense Type"/>
                                </td>
                                <td class="pa-0">
                                    <v-text-field v-model="newExpenseItem['notes']" :rules="[vRules.required]"
                                                  density="compact" hide-details label="Initial Notes"/>
                                </td>
                                <td class="pa-0">
                                    <v-text-field v-model="newExpenseItem['qty']" :rules="[vRules.required]"
                                                  density="compact" hide-details label="Qty" min="1" type="number"/>
                                </td>
                                <td class="pa-0">
                                    <v-text-field v-model="newExpenseItem['unit_cost']" :rules="[vRules.required]"
                                                  density="compact" hide-details label="Unit Cost" min="0.1"
                                                  type="number"/>
                                </td>
                                <td class="pa-0">
                                    <v-text-field v-model="newExpenseItem['tax']" :rules="[vRules.required]"
                                                  density="compact" hide-details label="Tax" min="0" type="number"/>
                                </td>
                                <td class="pa-0 text-center font-weight-bold">{{
                                        ((parseInt(newExpenseItem['qty'] ?? 1) * parseFloat(newExpenseItem['unit_cost'] ?? 0)) + parseFloat(newExpenseItem['tax'] ?? 0)).toFixed(2)
                                    }}
                                </td>
                                <td class="d-flex align-center">
                                    <v-btn icon="mdi-content-save" size="small" variant="text" @click="addExpenseItem"/>
                                    <v-btn :rules="[vRules.required]" color="black" icon="mdi-close" size="x-small"
                                           variant="text" @click="newExpenseItem = null"/>
                                </td>
                            </tr>
                            <tr v-for="(item,index) in expenseItems" :key="index">
                                <template v-if="selectedExpenseItem?.id === item.id">
                                    <td>
                                        <v-select v-model="formData['vehicle_expense_type_id']" :items="expenseTypes"
                                                  :rules="[vRules.required]" density="compact" hide-details
                                                  item-title="name" item-value="id" label="Expense Type"/>
                                    </td>
                                    <td>
                                        <v-text-field v-model="formData['notes']" :rules="[vRules.required]"
                                                      density="compact" hide-details/>
                                    </td>
                                    <td>
                                        <v-text-field v-model="formData['qty']" :rules="[vRules.required]"
                                                      density="compact" hide-details min="1" type="number"/>
                                    </td>
                                    <td>
                                        <v-text-field v-model="formData['unit_cost']" :rules="[vRules.required]"
                                                      density="compact" hide-details min="0.1" type="number"/>
                                    </td>
                                    <td>
                                        <v-text-field v-model="formData['tax']" :rules="[vRules.required]"
                                                      density="compact" hide-details min="0" type="number"/>
                                    </td>
                                    <td class="pa-0 text-center font-weight-bold">{{
                                            ((parseInt(formData['qty'] ?? 1) * parseFloat(formData['unit_cost'] ?? 0)) + parseFloat(formData['tax'] ?? 0)).toFixed(2)
                                        }}
                                    </td>
                                    <td class="d-flex align-center">
                                        <v-btn icon="mdi-content-save" size="small" variant="text"
                                               @click="updateTaskItem"/>
                                        <v-btn color="black" icon="mdi-close" size="x-small" variant="text"
                                               @click="selectedExpenseItem = null"/>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{ getExpenseType(item.vehicle_expense_type_id)?.name }}</td>
                                    <td>{{ item.notes }}</td>
                                    <td>{{ item.qty }}</td>
                                    <td>{{ item.unit_cost }}</td>
                                    <td>{{ item.tax }}</td>
                                    <td class="pa-0 font-weight-bold">{{
                                            ((parseInt(item['qty'] ?? 1) * parseFloat(item['unit_cost'] ?? 0)) + parseFloat(item['tax'] ?? 0)).toFixed(2)
                                        }}
                                    </td>
                                    <td>
                                        <v-btn color="black" icon="mdi-pencil-outline" size="small" variant="text"
                                               @click="selectItem(item)"/>
                                        <v-btn :rules="[vRules.required]" color="red" icon="mdi-close" size="x-small"
                                               variant="text" @click="deleteTaskItem(item,index)"/>
                                    </td>
                                </template>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <h4>Payment Details</h4>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-select v-model="expenseData['driver_payment_type_id']" :items="driverPaymentTypes"
                                  clearable density="compact" hide-details item-title="name"
                                  item-value="id" label="Payment Method"/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-text-field v-model="expenseData['receipt_id']" density="compact"
                                      hide-details label="Receipt ID"/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-text-field v-model="totals['cost']" density="compact" hide-details label="Total Cost"
                                      readonly type="number"/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-text-field v-model="totals['tax']" density="compact" hide-details label="Total Tax"
                                      readonly type="number"/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <v-text-field :model-value="totals['total_cost']" density="compact" hide-details
                                      label="Grand Total" readonly/>
                    </v-col>
                    <v-col class="py-1" cols="6">
                        <p><b>Updated by:</b> {{ expense.updated_by_user }}</p>
                        <p><b>Last updated:</b> {{ formatDateTime(expense.updated_at) }}</p>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn :disabled="!!selectedExpenseItem || !!newExpenseItem || !isDirty" color="black" size="small"
                       variant="outlined" @click="updateExpense">Save
                </v-btn>
                <v-btn size="small" type="button" variant="outlined" @click="closeDetails">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {send} from "@/composables/apiClient";
import {computed, onMounted, reactive, ref} from "vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {formatDateTime} from "@/composables/useTimezone";

const snackbar = useSnackbarStore();
const props = defineProps({
    driverPaymentTypes: Array,
    expenseTypes: Array,
    modelValue: Boolean,
    expense: Object,
    drivers: Array,
    asset: Object,
});

const emits = defineEmits(['update:modelValue', 'createExpense', 'updateExpense']);
const selectedExpenseItem = ref(null);
const dialogSwitch = ref(props.modelValue);
const newExpenseItem = ref(null);
const expenseItems = ref([]);
const errors = ref([]);

const formData = reactive({
    vehicle_expense_type_id: null,
    notes: null,
    unit_cost: null,
    qty: null,
    tax: null,
});
const expenseData = reactive({
    label: props.expense?.label ?? null,
    driver_id: props.expense?.driver_id ?? null,
    receipt_id: props.expense?.receipt_id ?? null,
    driver_payment_type_id: props.expense?.driver_payment_type_id ?? null,
})

onMounted(() => {
    if (props.expense) {
        fetchExpenseItems();
    }
})

// Tax may be 0, so "missing" means empty, not falsy.
const isBlank = (value) => value === null || value === undefined || value === '';

// The totals the server holds for this expense, refreshed by every line
// change. The sum of the lines on screen is only the fallback for an expense
// the server has no totals for yet.
const serverTotals = ref({
    cost: props.expense?.cost ?? null,
    tax: props.expense?.tax ?? null,
    total_cost: props.expense?.total_cost ?? null,
});
const takeServerTotals = (data) => {
    if (data?.expense_totals) {
        serverTotals.value = data.expense_totals;
    }
}

const isDirty = computed(() => {
    return Object.keys(expenseData).some(key => expenseData[key] !== props.expense[key])
})
const totals = computed(() => {
    const total = {
        cost: 0,
        tax: 0,
        total_cost: 0,
    }
    expenseItems.value.map((item) => {
        total.cost += parseFloat(item.unit_cost) * parseInt(item.qty);
        total.tax += parseFloat(item.tax);
    })
    total.cost = parseFloat(total.cost).toFixed(2);
    total.tax = parseFloat(total.tax).toFixed(2);

    total.total_cost = (parseFloat(total.cost) + parseFloat(total.tax)).toFixed(2);

    if (!isBlank(serverTotals.value.total_cost)) {
        return {
            cost: parseFloat(serverTotals.value.cost ?? 0).toFixed(2),
            tax: parseFloat(serverTotals.value.tax ?? 0).toFixed(2),
            total_cost: parseFloat(serverTotals.value.total_cost).toFixed(2),
        };
    }
    return total;
})

const addItem = () => {
    selectedExpenseItem.value = null;
    newExpenseItem.value = {
        vehicle_expense_type_id: null,
        unit_cost: null,
        qty: null,
        tax: null,
        notes: null,
    };
}
const selectItem = (item) => {
    selectedExpenseItem.value = item;
    formData['vehicle_expense_type_id'] = selectedExpenseItem.value?.vehicle_expense_type_id ?? null;
    formData['notes'] = selectedExpenseItem.value?.notes ?? null;
    formData['unit_cost'] = selectedExpenseItem.value?.unit_cost ?? null;
    formData['tax'] = selectedExpenseItem.value?.tax ?? null;
    formData['qty'] = selectedExpenseItem.value?.qty ?? null;
}
const getExpenseType = (id) => {
    return props.expenseTypes.find((record) => record.id === id)
}

const fetchExpenseItems = () => {
    send('get', `fleet/expenses/${props.expense.id}/items`)
        .then((response) => {
            if (response.data.success) {
                expenseItems.value = response.data.data ?? [];
            }
        })
        .catch(function (error) {
            console.log(error)
            snackbar.showSnackbar('Something went wrong', 'error');
        })
}
const updateExpense = () => {
    errors.value = [];
    // Card and receipt are optional: expenses filed from the driver app have
    // neither, and must still be editable.
    if (!expenseData['label'] || !expenseData['driver_id']) {
        errors.value.push("Label and driver are required");
        return;
    }

    send('put', `fleet/expenses/${props.expense.id}`, expenseData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateExpense', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
const addExpenseItem = () => {
    errors.value = [];
    if (
        !newExpenseItem.value.vehicle_expense_type_id ||
        !newExpenseItem.value.unit_cost ||
        !newExpenseItem.value.qty ||
        isBlank(newExpenseItem.value.tax)
    ) {
        errors.value.push("All fields are required!");
        return;
    }
    send('post', `fleet/expenses/${props.expense.id}/items`, newExpenseItem.value)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                expenseItems.value.unshift(response.data.data);
                takeServerTotals(response.data.data);
                newExpenseItem.value = null;
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
const updateTaskItem = () => {
    errors.value = [];
    if (
        !formData['vehicle_expense_type_id'] ||
        !formData['unit_cost'] ||
        !formData['qty'] ||
        isBlank(formData['tax'])
    ) {
        errors.value.push("All fields are required!");
        return;
    }
    send('put', `fleet/expenses/${selectedExpenseItem.value.id}/items`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                expenseItems.value.map((record, index) => {
                    if (record.id === selectedExpenseItem.value.id) {
                        expenseItems.value[index] = response.data.data;
                    }
                });
                takeServerTotals(response.data.data);
                selectedExpenseItem.value = null;
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
const deleteTaskItem = (item, index) => {
    if (!confirm("Are you sure to delete expense item?")) {
        return;
    }
    send('delete', `fleet/expenses/${item.id}/items`)
        .then((response) => {
            if (response.data.success) {
                expenseItems.value.splice(index, 1)
                takeServerTotals(response.data.data);
                snackbar.showSnackbar(response.data.message);
            }
        })
        .catch(function (errorResponse) {
            snackbar.showSnackbar(errorResponse.response.data.message ?? 'Something went wrong', 'error');
        })
}
const closeDetails = () => {
    const data = {
        'tax': parseFloat(totals.value.tax),
        'cost': parseFloat(totals.value.cost),
        'total_cost': parseFloat(totals.value.total_cost),
    };
    emits('updateExpense', {...props.expense, ...data});
    emits('update:modelValue', false);
}
</script>
